import React, { useEffect, useState, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import Dropdown from 'react-bootstrap/Dropdown'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import PaymentsListModal from '../../modals/PaymentsListModal';
import { Accordion, AccordionTab } from 'primereact/accordion';
import StoreInfo from '../../parts/StoreInfo';
import ProfileContext from '../../../services/profileContext';
import { MdHandyman } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import CancelItemsFormModal from '../../modals/CancelItemsFormModal';
import { parse } from 'date-fns';

export default function SalesOrderView (){
    const {
        account
    } = useContext(ProfileContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', '₱');
    const tax_enabled = helpers.getSettingValue(account?.settings, 'tax_enabled', 1);
    const discount_enabled = helpers.getSettingValue(account?.settings, 'discount_enabled', 1);
    const single_label = helpers.getSettingValue(account?.settings, 'sales_order_single_label', 'Sales Order');
    const plural_label = helpers.getSettingValue(account?.settings, 'sales_order_plural_label', 'Sales Order');
    const heading_label = `Manage ${plural_label}`;
    const invoice_label = helpers.getSettingValue(account?.settings, 'invoice_single_label', 'Invoice');
    const page_title = `${single_label} Details`;

    const { order_id } = useParams();
    const [loading, setLoading] = useState(1);
    //const [page_title, setPageTitle] = useState(`${single_label} Details`);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(store.sales_order_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [invoice_table, setInvoiceTable] = useState([]);

    const [cancel_items_modal, setCancelItemsModal] = useState(false);
    const [cancelled_table, setCancelledTable] = useState([]);
    const navigate = useNavigate();
    
   
    useEffect(() => {
        initTreeView()
        if(order_id){
            fetchData()
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    useEffect(() => {
        displayInvoiceItems()
        displayCancelledItems()
    }, [record_data]);

    function fetchData(){
        // if(!order_id){
        //     return
        // }
        const url = helpers.createUrl(`V1/manage/order/sales/${order_id}?store_id=${helpers.getStoreID()}`)
        
        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.order_date = new Date(res.order_date)

            setLoading(0)
            setRecordData(items)
            setRecordItems(items.items)
            setRecordLoaded(1)
        })
        .catch((err) => {
            setLoading(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/sales/list");
                }
            })
        }); 

    }
    function computeSubTotals(){
        let items = 0;
        let total_amount = 0

        record_items.forEach((data) => {
            const quantity = parseInt(data.quantity ?? '0', 10);
            const price = parseFloat(data.amount ?? '0');
            const discount = parseFloat(data.discount_amount ?? '0');

            const totalPrice = price * quantity
            const netPrice = totalPrice - discount;

            items += quantity;
            total_amount += netPrice
        });

        return helpers.formatCurrencyAmount(total_amount, default_currency);
    }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>
                        <div className='mb-0'>{data.product_name}{data.product_variant_name != 'Generic' ? ` (${data.product_variant_name})` : ''}</div>
                        {data.product_description ? <div className='mt-2' style={{whiteSpace: 'pre-line', maxHeight: '150px', overflow: 'auto', fontSize: '12px'}}>{data.product_description}</div> : ''}
                    </td>
                    {/* <td>{data.product_code}</td> */}
                    <td>{data.quantity}{data.unit_name ? <small> {data.unit_name}</small> : ''}</td>
                    <td>
                        <p className='mb-1'>{data.fulfilled_quantity} Fulfilled</p>
                        <p className='mb-1'>{data.returned_quantity} Returned</p>
                        {
                            parseFloat(data.cancelled_quantity) ?  
                            <p className='mb-1 text-danger'>{helpers.normalizeDecimal(data.cancelled_quantity)} Cancelled</p> : ''
                        }
                    </td>
                    {/* <td>{data.returned_quantity}</td> */}
                    <td>{helpers.formatCurrencyAmount(data.amount, default_currency)}</td>
                    {parseInt(discount_enabled) ? 
                    <td>
                        {helpers.formatCurrencyAmount(data.discount_amount, default_currency)}<br/>
                        <small>{data.discount_name ? `(${data.discount_name})` : ''}</small>
                    </td> : ''
                    }
                    <td>{helpers.formatCurrencyAmount(data.total_amount, default_currency)}</td>
                </tr>)

            })
        }

        setTableItems(<tbody>{items}</tbody>)
    }

    function displayInvoiceItems(){
        if (Object.entries(record_data.invoice).length) {
            let items = []
            const invoice = record_data.invoice
            items = <tr>
                        <td>{invoice.invoice_date}</td>
                        <td><Link to={`/invoices/${invoice.id}`} target='_blank'>{invoice.invoice_no}</Link></td>
                        <td>{invoice.due_date}</td>
                        <td>{helpers.formatCurrencyAmount(invoice.total_amount, default_currency)}</td>
                        <td>{helpers.formatCurrencyAmount(invoice.balance_amount, default_currency)}</td>
                        <td>{invoice.invoice_status}</td>
                        <td width={20}>
                            <div  className='text-center'>
                            <Dropdown as={ButtonGroup} drop="down" className='mr-sm-2' size="sm" >
                                <Dropdown.Toggle variant="outline-dark" id="dropdown-split-basic" />
                                <Dropdown.Menu>
                                    { account?.user.type !== 'customer' && <Dropdown.Item href={`/invoices/${invoice.id}/payment`} target='_blank'><i className="fas fa-credit-card mr-2" style={{width: '20px'}} />Add Payment</Dropdown.Item>}
                                    <Dropdown.Item href={`/invoices/${invoice.id}/print`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                    { account?.user.type !== 'customer' && <Dropdown.Item onClick={(e) => triggerAction(invoice.id, 'single-delete')} className='text-danger'><i className="fas fa-trash mr-2" style={{width: '20px'}} />Delete</Dropdown.Item>}
                                </Dropdown.Menu>
                            </Dropdown>
                            </div>
                        </td>
                    </tr>

            setInvoiceTable(<div className="container mb-3">
                <Accordion>
                    <AccordionTab header={`Associated ${invoice_label}`} className="text-dark">
                        <div className='table-responsive-md'>
                        <table className="table table-sm mb-0">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Invoice #</th>
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Balance</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>{items}</tbody>
                        </table>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>)
        }
    }

    function displayCancelledItems(){
        if(hasCancelledQuantity(record_items)){
            let tableItems = []
            
            tableItems = Object.entries(record_items).map(([key, data]) => {
                if(!parseFloat(data.cancelled_quantity)) return
                return(
                    <tr>
                        <td>{data.product_name}</td>
                        <td>{data.quantity}</td>
                        <td>{helpers.normalizeDecimal(data.cancelled_quantity)}</td>
                    </tr>
                )

            })

            setCancelledTable(<div className="container mb-3">
                <Accordion>
                    <AccordionTab header={`Cancelled Items`} className="text-dark">
                        <div className='table-responsive-md'>
                        <table className="table table-sm mb-0">
                            <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Ordered Quantity</th>
                                <th>Cancelled Quantity</th>
                            </tr>
                            </thead>
                            <tbody>{tableItems}</tbody>
                        </table>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>)
        }
    }

    function triggerAction(data, action = '', order_id = '', status = ''){
        if(!action) return;

        if(action === 'create-service'){
            createServiceRequest(data)
            return
        }
        else if(action === 'cancel-items'){
            setCancelItemsModal(true)
            
            return
        }
        else if(action === 'redo-cancellation'){
            redoCancellation()
            return
        }
        else if(action === 'force-fulfillment'){
            forceFulfillment(data, 'fulfill')
            return;
        }
        else if(action === 'redo-fulfillment'){
            forceFulfillment(data, 'redo')
            return;
        }
        else if(action === 'instant-invoice'){
            createInvoice(data)
            return;
        }
        else if(action === 'open'){
            updateStatusItem(1)
        }
        else if(action === 'confirm'){
            updateStatusItem(2)
        }
        else if(action === 'single-delete' || action === 'bulk-delete'){
            let ids = [];
            ids.push(data)

            let title = 'Delete Invoice'

            Swal.fire({
                title: title,
                text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
                showCancelButton: true,
                showConfirmButton: false,
                closeOnCancel: true,
                showDenyButton: true,
                denyButtonText: 'Yes'
            })
            .then((result) => {
                if (result.isDenied) {
                    deleteItem(ids)
                }
            })
        }

        //updateStatusItem(order_id, status)
    }

    function redoCancellation(){
        setLoading(0)
        const url = helpers.createUrl(`V1/manage/order/sales/redo-cancellation`)

            httpRequest(url, 'POST', {
                postdata: {
                    "id": order_id
                },
            }, true)
            .then((res) => {
                // setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function deleteItem(id){
        const url = helpers.createUrl('V1/manage/invoices/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "invoice_ids": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function forceFulfillment(id, action = ''){
        const url = helpers.createUrl(`V1/manage/order/sales/${id}/fulfillment`)
        httpRequest(url, 'POST', {
            postdata: {
                "action": action,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 

    }

    function updateStatusItem(status_id){
        const url = helpers.createUrl('V1/manage/order/sales/status')
        httpRequest(url, 'POST', {
            postdata: {
                "order_id": order_id,
                "store_id": helpers.getStoreID(),
                "status_id": status_id
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK"
                })
            }); 
    }

    function createInvoice(id){
        const url = helpers.createUrl('V1/manage/order/sales/invoice')
        httpRequest(url, 'POST', {
            postdata: {
                "order_id": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 

    }

    function createServiceRequest(id){
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/create-from-orders`)
        setLoading(1)
        httpRequest(endpoint, 'POST', {
            postdata: {
                "reference_id": id,
                "reference_type": 'sales-order'
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/service-requests/${res?.data?.id}/form`);
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function handleCancelItems(e){
        Swal.fire({
            title: "Success",
            text: e.message,
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false
        })
        .then((result) => {
            if (result.isConfirmed) {
                window.location.reload();
            }
        })
    }

    function hasCancelledQuantity(items) {
        return items.some(item => parseFloat(item.cancelled_quantity) > 0);
    }

    function isOrderFullyFulfilled(items) {
        const totalQuantity = items.reduce(
            (sum, item) => sum + Number(item.quantity),
            0
        );

        const totalFulfilled = items.reduce(
            (sum, item) => sum + Number(item.fulfilled_quantity),
            0
        );

        return totalQuantity === totalFulfilled;
    }

    return (
        <>
        <PaymentsListModal show_modal={payments_modal} id={order_id} close_modal={setPaymentsModal} />

        <CancelItemsFormModal 
            origin='sales-order'
            reference_id={order_id}
            is_show={cancel_items_modal} 
            setShow={setCancelItemsModal} 
            handleSave={handleCancelItems} 
        />

        <Layout page_title={page_title} menu="manage-sales" breadcrumbs={true} parent_link='/sales/list' parent_text={heading_label}>
                <div className="content" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div order_id="so-customer-section" className="col-lg-12">
                                    {record_loaded ?
                                    <div className='border rounded p-3 mb-3 d-flex justify-content-between align-items-center'>

                                        <h5 className='mb-0 mb-md-0 d-flex'>{record_data.order_no}</h5>

                                        <div className='d-sm-flexs flex-column flex-sm-row d-nones'>
                                            <Dropdown as={ButtonGroup} drop="down" className='mr-2' >
                                                <Dropdown.Toggle variant="outline-dark" id="dropdown-split-basic" />
                                                <Dropdown.Menu>
                                                    {
                                                        parseInt(record_data.order_status_id) === 2 
                                                        && !hasCancelledQuantity(record_items) 
                                                        && !isOrderFullyFulfilled(record_items) 
                                                        && account?.user.type !== 'customer' ? 
                                                        <Dropdown.Item onClick={(e) => triggerAction(order_id, 'cancel-items')}><i className="fas fa-ban mr-2" style={{width: '20px'}} />Cancel Items</Dropdown.Item> : ''
                                                    }

                                                    {
                                                        parseInt(record_data.order_status_id) === 2 
                                                        && hasCancelledQuantity(record_items)
                                                        && account?.user.type !== 'customer' 
                                                        &&  <Dropdown.Item onClick={(e) => triggerAction(order_id, 'redo-cancellation')}><TbRefresh size={22} className='mr-2' />Reopen cancelled items</Dropdown.Item>
                                                    }

                                                    {
                                                        parseInt(record_data.order_status_id) !== 1 && account?.user.type !== 'customer' ?
                                                        <Dropdown.Item onClick={(e) => triggerAction(order_id, 'create-service')}><MdHandyman size={22} className='mr-2' />Create Service Request</Dropdown.Item> : ''
                                                    }

                                                    {
                                                        parseInt(record_data.order_status_id) !== 1 && 
                                                        (parseInt(record_data.shipping_status_id) === 1 || parseInt(record_data.shipping_status_id) === 2 || parseInt(record_data.shipping_status_id) === 3) && account?.user.type !== 'customer' ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'force-fulfillment')}><i className="fas fa-shipping-fast mr-2" style={{width: '20px'}} />Instant Fulfillment</Dropdown.Item> : ''
                                                    }

                                                    {
                                                    record_data.force_fulfillment && account?.user.type !== 'customer' ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'redo-fulfillment')}><i className="fas fa-redo mr-2" style={{width: '20px'}} />Redo Instant Fulfillment</Dropdown.Item> : ''
                                                    }

                                                    {
                                                    parseInt(record_data.order_status_id) === 1 && account?.user.type !== 'customer' ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'confirm', 2)}><i className="fas fa-check-circle mr-2" style={{width: '20px'}} />Set as Confirm</Dropdown.Item> : ''
                                                    }
        
                                                    {
                                                    parseInt(record_data.order_status_id) === 2 && parseInt(record_data.shipping_status_id) === 1 && account?.user.type !== 'customer' ?
                                                    <Dropdown.Item onClick={(e) => triggerAction(order_id, 'open', 1)}><i className="fas fa-file-alt mr-2" style={{width: '20px'}} />Set as Open</Dropdown.Item> : ''
                                                    }

                                                    {
                                                        parseInt(record_data.order_status_id) !== 3 && parseInt(record_data.order_status_id) !== 4 && (parseInt(record_data.shipping_status_id) === 1 || parseInt(record_data.shipping_status_id) === 2) ?
                                                        <Dropdown.Item as={Link} to={`/sales/${order_id}/edit`}><i className="fas fa-pencil-alt mr-2" style={{width: '20px'}} />Edit</Dropdown.Item>:''
                                                    }

                                                    <Dropdown.Item href={`/sales/${order_id}/print`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            
                                            {
                                            (parseInt(record_data.order_status_id) === 2 || (parseInt(record_data.shipping_status_id) !== 1 && parseInt(record_data.shipping_status_id) !== 2))  && account?.user.type !== 'customer' ?
                                            <Dropdown as={ButtonGroup} drop="down" className='mr-2' >
                                                <Dropdown.Toggle variant="outline-primary" id="dropdown-split-basic">
                                                    Create
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>

                                                    {   
                                                        parseInt(record_data.order_status_id) === 2 ? 
                                                        <Dropdown.Item onClick={(e) => triggerAction(order_id, 'instant-invoice')}><i className="fas fa-file-invoice mr-2" style={{width: '20px'}} />Instant Invoice</Dropdown.Item>:''
                                                    }
                                                    
                                                    {
                                                        parseInt(record_data.shipping_status_id) !== 1 && parseInt(record_data.shipping_status_id) !== 2 ?
                                                        <Dropdown.Item as={Link} to={`/sales/${order_id}/sales-return`}><i className="fas fa-sign-in-alt mr-2" style={{width: '20px'}} />Sales Return</Dropdown.Item> : ''
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown> : ''
                                            }

                                            <Link className='btn btn-dark' to="/sales/list">Cancel</Link>  
                                        </div>
                                    </div> : ''}
                                </div>
                            </div>
                    </div>

                    {
                        invoice_table
                    }

                    {
                        cancelled_table
                    }

                            
                    <div className="container">
                        {
                            record_loaded ?
                            <div className="invoice p-4 mb-3">
                                <div className="d-flex justify-content-between mb-3">
                                    <StoreInfo store={record_data.store_info} />

                                    <div className='text-right'>
                                        <h2><strong>{helpers.capitalizeString(single_label)}</strong></h2>
                                        <h5>{helpers.displayOrderStatusBadge(record_data.order_status_id, record_data.order_status)}</h5>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-4 mb-3">
                                        <h5 className='mb-0'><b>Bill To:</b></h5>
                                        <div>
                                            <p className='mb-0'><b>{record_data.customer_name}</b></p>
                                            <p className='mb-0'>{record_data.billing_address}</p>
                                            <p className='mb-0'>{record_data.billing_phone}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <h5 className='mb-0'><b>Ship To:</b></h5>
                                        <div>
                                            <p className='mb-0'><b>{record_data.shipping_contact_name}</b></p>
                                            <p className='mb-0'>{record_data.shipping_address}</p>
                                            <p className='mb-0'>{record_data.shipping_phone}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 text-lg-right mb-2">
                                        <table className='table table-borderless table-sm'>
                                            <tbody>
                                                <tr>
                                                    <td className='py-0'><b>Order #:</b></td>
                                                    <td className='py-0'>{record_data.order_no ? record_data.order_no : '---'}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Date:</b></td>
                                                    <td className='py-0'>{helpers.formatDate(record_data.order_date)}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Payment Terms:</b></td>
                                                    <td className='py-0'>{record_data.payment_term ? record_data.payment_term : '---'}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Shipment:</b></td>
                                                    <td className='py-0'>{record_data.shipping_status ? record_data.shipping_status : '---'}</td>
                                                </tr>
                                                {
                                                    record_data.order_status_id == 4
                                                    ?
                                                    <>
                                                    <tr>
                                                        <td className='py-0'><b>Cancellation Reason:</b></td>
                                                        <td className='py-0'>{record_data.reason}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='py-0'><b>Cancellation Remarks:</b></td>
                                                        <td className='py-0'>{record_data.cancel_remarks ? record_data.cancel_remarks : 'N/A'}</td>
                                                    </tr>
                                                    </>
                                                    : ''
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className='table table-striped table-sm border-bottom'>
                                        <thead>
                                            <tr>
                                                <th>Item & Description</th>
                                                {/* <th>SKU</th> */}
                                                <th>Ordered</th>
                                                <th>Status</th>
                                                {/* <th>Returned</th> */}
                                                <th>Price</th>
                                                {parseInt(discount_enabled) ? <th>Discount</th> : ''}
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        {
                                            table_items
                                        }
                                    </table>
                                </div>

                                <div className='row'>
                                    <div className="col-lg-7 d-flex align-items-center">{record_data.customer_notes ? <p className='pt-1 pt-lg-4'>{record_data.customer_notes}</p>:''}</div>
                                    <div className="col-lg-5 mb-0 border p-2">
                                        <table className='table table-sm table-borderless mb-0'>
                                            <tbody>
                                                <tr>
                                                    <td className='border-top-0'><b>Sub Total</b></td>
                                                    <td className='border-top-0'>{computeSubTotals()}</td>
                                                </tr>
                                                {parseInt(discount_enabled) ?
                                                <tr>
                                                    <td><b>Total Discount</b></td>
                                                    <td>{parseFloat(record_data.total_discount) > 0 ? helpers.formatCurrencyAmount(record_data.total_discount, default_currency) : helpers.formatCurrencyAmount(0, default_currency)}</td>
                                                </tr> : ''
                                                }
                                                <tr>
                                                    <td><b>Shipping Fee</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.shipping_fee, default_currency)}</td>
                                                </tr>
                                                {parseInt(tax_enabled) ?
                                                <tr>
                                                    <td><b>Total Tax</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.total_tax, default_currency)}</td>
                                                </tr> : ''
                                                }
                                                <tr className='bg-dark'>
                                                    <td><b>Total</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.total_amount, default_currency)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            : 
                            <div className="invoice p-5 mb-3">
                                <h4>&nbsp;</h4>
                            </div>
                        }
                    </div>
                </div>
        </Layout>
        </>
    )
}